import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {
  ACTUALIZARESTADOSEMANA, ACTUALIZARHORARIOSEMANA,
  ACTUALIZARPRESUPUESTOSEM,
  CONSULTARINFOSEM,
  CREARHORARIO,
  CREARSEMANAS, DEVOLVERANOACTUAL, DEVOLVERFECHASERVIDOR,
  DEVOLVERINFOTIENDA,
  DEVOLVERVENTAS, DEVOLVERVENTASTS, DEVOLVERVENTASVENDEDOR, GETSEMANACALENDARIOTIENDA
} from '../queries/semanas.query';
import {SemanaModel} from '../models/semana.model';
import {DiaTypes, HoraTypes, MallaPorcentajeTypes, SemanaTypes} from '../types/semana.types';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {Observable} from 'rxjs';

@Injectable()
export class SemanaServices {

  public obsSendInconsistencia: Observable<any>;

  constructor(private apollo: Apollo, private ss: SocketServices) {
    this.obsSendInconsistencia = this.ss.registrarEvento('inconsistencia');
  }

  devolverPrimerDia(ano: number) {

    return this.apollo.query<any>({
      query: DEVOLVERANOACTUAL,
      variables: {
        ano: ano
      }
    });

  }

  //
  // devolverSemanaXNumSem(numSem: number) {
  //
  // }
  //
  //
  // devolverTodasSemanas() {
  //
  //   return [];
  //
  //
  // }

  devolverVentasTS(ano: any, semana: any, tienda: any) {

    return this.apollo.query<any>({
      query: DEVOLVERVENTASTS,
      variables: {
        ano: ano,
        semana: semana,
        tienda: tienda
      }
    });
  }

  devolverVentas(ano: any, semana: any, tienda: any) {

    return this.apollo.query<any>({
      query: DEVOLVERVENTAS,
      variables: {
        ano: ano,
        semana: semana,
        tienda: tienda
      }
    });
  }

  devolverVentasEmpleado(ano: any, semana: any, tienda: any) {

    return this.apollo.query<any>({
      query: DEVOLVERVENTASVENDEDOR,
      variables: {
        ano: ano,
        semana: semana,
        tienda: tienda
      }
    });
  }


  crearSemana(ventas: any[], primerDia: any) {
    let semana: SemanaModel = new SemanaModel(primerDia);

    for (let v of ventas) {
      semana.agregarVenta(v);
    }

    semana.recalcular();

    console.log(semana);
    return semana;
  }


  guardarHorarios(fecha: string, tiendas: string[], horario: any) {
    return this.apollo.mutate<any>({
      mutation: CREARHORARIO,
      variables: {
        fecha: fecha,
        tiendas: tiendas,
        horario: JSON.stringify(horario)
      }
    });
  }


  // formato de ano ano-numSemana
  guardarSemanas(semana: SemanaModel, tiendas: string[], fecha: string) {


    let sem: SemanaTypes = new SemanaTypes();


    sem.fecha = fecha;
    sem.mPorcentaje = new MallaPorcentajeTypes();


    for (let d of semana.mPorcentaje.dias) {
      let dia = new DiaTypes();
      dia.txtDia = d.txtDia;
      dia.porcentaje = d.porcentaje;
      dia.precio = d.precio;


      for (let h of d.horas) {
        let horas = new HoraTypes();
        horas.porcentaje = h.porcentaje;
        horas.txtHora = h.txtHora;
        horas.precio = h.precio;
        dia.horas.push(horas);
      }

      sem.mPorcentaje.dias.push(dia);

    }



    return this.apollo.mutate<any>({
      mutation: CREARSEMANAS,
      variables: {
        fecha: fecha,
        tiendas: tiendas,
        semana: JSON.stringify(sem)
      }
    });
  }

  devolverInfoSemana(fecha: string) {
    return this.apollo.query<any>({
      query: CONSULTARINFOSEM,
      variables: {
        fecha: fecha
      }
    });
  }

  actualizarHorarioSemana(id: string, horario: string) {

    return this.apollo.mutate({
      mutation: ACTUALIZARHORARIOSEMANA,
      variables: {
        id: id,
        horario: horario
      }
    });
  }

  devolverInfoTienda(fecha: string, idDB: string, ano: number, sem: number) {

    return this.apollo.query<any>({
      query: DEVOLVERINFOTIENDA,
      variables: {
        fecha: fecha,
        tienda: idDB,
        ano: ano,
        semana: sem,
        ti: idDB,
        semAnt: (sem - 1 < 0) ? 53 : sem - 1,
        anoAnt: (sem - 1 < 0) ? ano - 1 : ano
      }
    });
  }

  devolverSemanaCalendarioTienda(fechaIni: string, fechaFin: string, tienda: string) {
    return this.apollo.query({
      query: GETSEMANACALENDARIOTIENDA,
      variables: {
        fechaIni: fechaIni,
        fechaFin: fechaFin,
        tienda: tienda
      }
    });
  }

  actualizarEstadoSemana(fecha: string, tienda: string, estado: any) {

    return this.apollo.mutate<any>({
      mutation: ACTUALIZARESTADOSEMANA,
      variables: {
        fecha: fecha,
        tienda: tienda,
        estado: JSON.stringify(estado)
      }
    });
  }

  actualizarPresupuestoSemana(semanas: SemanaModel[]) {

    let observables = [];

    semanas.map(s => {
      let sem: SemanaTypes = new SemanaTypes();


      sem.fecha = s.fecha;
      sem.mPorcentaje = new MallaPorcentajeTypes();
      sem.ventasSem = s.ventasSem;
      sem.estado = s.estado;
      sem.id = s.id;

      for (let d of s.mPorcentaje.dias) {
        let dia = new DiaTypes();
        dia.txtDia = d.txtDia;
        dia.porcentaje = d.porcentaje;
        dia.precio = d.precio;
        dia.fecha = d.fecha;

        for (let h of d.horas) {
          let horas = new HoraTypes();
          horas.porcentaje = h.porcentaje;
          horas.txtHora = h.txtHora;
          horas.precio = h.precio;
          dia.horas.push(horas);
        }

        sem.mPorcentaje.dias.push(dia);

      }


      let obs = this.apollo.mutate<any>({
        mutation: ACTUALIZARPRESUPUESTOSEM,
        variables: {
          datos: JSON.stringify(sem)
        }
      });

      observables.push(obs);
    });


    return observables;


  }

  devolverInconsistenciaSemana(semana: any, ano: any) {
    this.ss.enviarEvento('inconsistencia', {semana: semana, ano: ano});
  }

  devolverFechaServidor(){
    return this.apollo.query({
      query:DEVOLVERFECHASERVIDOR
    })
  }
}
